import { useAsync, useMountEffect } from "@react-hookz/web";
import { useMemo } from "react";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import type { hooksHeaderMenuDisplayQuery } from "~/queries/__generated__/hooksHeaderMenuDisplayQuery.graphql";

export const useMenuData = () => {
  const environment = useRelayEnvironment();

  const [{ result: data }, { execute }] = useAsync(() =>
    fetchQuery<hooksHeaderMenuDisplayQuery>(
      environment,
      graphql`
        query hooksHeaderMenuDisplayQuery {
          queue(filter: { name: "posties_menu_read" }) {
            items(first: 14) {
              edges {
                node {
                  ... on Section {
                    urlAlias
                    name
                  }
                }
              }
            }
          }
        }
      `,
      {
        name: "posties_menu_read",
      },
    ).toPromise(),
  );

  useMountEffect(() => {
    void execute();
  });

  const menuData = useMemo(
    () => [
      {
        name: "Read",
        subMenuLinkProps:
          data?.queue?.items?.edges.map(item => ({
            name: item.node.name ?? "",
            urlAlias: item.node.urlAlias ?? "",
          })) ?? [],
        urlAlias: "/posties/kids",
      },
      {
        name: "Video",
        urlAlias: "/posties/video",
      },
      {
        name: "ePaper",
        urlAlias: "/epaper",
      },
    ],
    [data?.queue?.items?.edges],
  );

  return { menuData };
};
